import { computed, defineAsyncComponent } from 'vue'

const iconModules = import.meta.glob('/node_modules/lucide-vue-next/dist/esm/icons/*.js')

export default function useDynamicIcon(icon) {
  const iconComponent = computed(() => {
    if (!icon()) {
      return null
    }

    const filename = icon() + '.js'
    const importer = iconModules[`/node_modules/lucide-vue-next/dist/esm/icons/${filename}`]

    return importer ? defineAsyncComponent(importer) : null
  })

  return {
    iconComponent,
  }
}
